import { all, takeLatest, put, call, takeEvery } from 'redux-saga/effects';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';
import {
  fetchConnectConfig,
  updateConnectConfig,
} from '../routines/connectConfigRoutines';

function* fetchConnectConfigSaga() {
  try {
    const url = `${envConfig.APIG_URL}core/connect-configs`;
    const response = yield call(request, url);
    const configs = response.data;
    yield put(fetchConnectConfig.success({ data: configs }));
  } catch (error) {
    yield put(fetchConnectConfig.failure({ error }));
  }
}

function* updateConnectConfigSaga({ payload }) {
  try {
    const url = `${envConfig.APIG_URL}core/connect-configs`;
    const response = yield call(request, url, {
      method: 'PUT',
      payload,
    });
    const configs = response.data;
    yield put(
      updateConnectConfig.success({
        data: configs,
        successMessage: SUCCESS_MESSAGES.CONNECT_WIDGET_CONFIGURE_SUCCESS,
      })
    );
    yield put(fetchConnectConfig.trigger());
  } catch (error) {
    yield put(updateConnectConfig.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchConnectConfig.TRIGGER, fetchConnectConfigSaga),
    takeEvery(updateConnectConfig.TRIGGER, updateConnectConfigSaga),
  ]);
}
